<template>
  <div class="body-container">
    <div class="box" v-if="!isWap">
      <el-tooltip
        effect="light"
        :content="qrcodeTargetShow ? '扫码登录' : '账号登录'"
        placement="left"
        :value="true"
        manual
        popper-class="login-tooltip"
      >
        <div class="hide-position"></div>
      </el-tooltip>
      <a
        href="javascript:void(0);"
        class="qrcode-target qrcode-target-show"
        :class="{
          'qrcode-target-hide': !qrcodeTargetShow,
          'qrcode-target-show': qrcodeTargetShow,
        }"
        :title="qrcodeTargetTitle"
        @click="switchQrcode()"
      ></a>
      <template v-if="qrcodeTargetShow">
        <h2>企业登录</h2>
        <el-form
          :model="loginForm"
          :rules="loginRule"
          ref="loginForm"
          class="login-form"
          @submit.native.prevent
        >
          <el-form-item prop="username">
            <el-input
              ref="username"
              v-model="loginForm.username"
              placeholder="请输入账号"
              :maxlength="11"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              :maxlength="30"
              v-model="loginForm.password"
              placeholder="请输入密码"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="verify_code" v-if="showSecurityCode">
            <el-row>
              <el-col :span="12">
                <el-input
                  v-model="loginForm.verify_code"
                  placeholder="请输入验证码"
                  :maxlength="4"
                ></el-input>
              </el-col>
              <el-col
                :span="12"
                style="display: flex; justify-content: space-evenly"
              >
                <img
                  alt="点击换图"
                  title="点击换图"
                  :src="captchaSrc"
                  @click="refreshCaptcha()"
                />
                <el-button
                  type="text"
                  @click="refreshCaptcha()"
                  style="color: #666666"
                  >换一张</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="remember" class="remember">
            <el-checkbox v-model="loginForm.remember">记住我</el-checkbox>
            <router-link to="/forget" class="forget-link">忘记密码</router-link>
          </el-form-item>
          <el-form-item>
            <el-button
              class="form-btn"
              type="primary"
              native-type="submit"
              @click="submitForm('loginForm')"
              >登录</el-button
            >
          </el-form-item>
          <!-- <el-form-item>
            <span>还没有账号？</span>
            <router-link to="/register">立即注册</router-link>
          </el-form-item> -->
        </el-form>
      </template>
      <template v-else>
        <h2>扫码登录</h2>
        <div class="qrcode-container">
          <div class="qrcodeState">
            <div v-if="operationType === '1'">
              <div class="qrcode-success-title">
                <i class="el-icon-circle-check"></i>
                <div>扫描成功!</div>
                <div>请勿刷新本页面</div>
              </div>
            </div>
            <div v-else-if="operationType === '3'">
              <div class="qrcode-error-mask"></div>
              <div class="qrcode-error-title">
                登录失败
                <div class="refresh-btn" @click="refreshQrcode()">刷新</div>
              </div>
            </div>
            <div v-else-if="operationType === '4'">
              <div class="qrcode-error-mask"></div>
              <div class="qrcode-error-title">
                二维码已失效
                <div class="refresh-btn" @click="refreshQrcode()">刷新</div>
              </div>
            </div>
            <div v-else></div>
          </div>
          <canvas id="qrcode"></canvas>
          <div class="qrcode-tip">请使用工业BIAPP</div>
          <div class="qrcode-tip">扫描二维码登录</div>
        </div>
      </template>
    </div>
    <div class="box_wap" v-if="isWap">
      <h4>
        我们暂时不支持手机浏览<br />
        为了获得更好的浏览体验，我们强烈建议您使用电脑浏览。
      </h4>
    </div>
  </div>
</template>

<script>
import { interval } from "rxjs";
import { switchMap } from "rxjs/operators";
import axios from "axios";
import EnvConfig from "@/const/configs/env.config.js";
import { CommonHelper } from "@/utils/common.helper.js";
import * as QRCode from "qrcode";

export default {
  name: "ros-login",
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!/^\d{0,11}$/.test(value)) {
        callback(new Error("账号格式错误"));
      } else {
        callback();
      }
    };
    return {
      timer$: null,
      qrcodeData: "",
      qrcodeTargetShow: true,
      qrcodeTargetTitle: "扫码登录",
      qrcodeCreateTime: 0,
      operationType: "",
      containerStyle: {
        minHeight: window.innerHeight - 234 + "px",
      },
      captchaSrc: "",
      showSecurityCode: false,
      loginForm: {
        username: "",
        password: "",
        verify_code: "",
        remember: false,
      },
      loginRule: {
        username: [
          { required: true, message: "账号不能为空", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        verify_code: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
        ],
      },
      isWap: false,
    };
  },
  mounted() {
    localStorage.setItem("url", EnvConfig.WEBSITE_DOMAIN + "/index");
    this.$refs.username.focus();
    const token = CommonHelper.getCookie("accessToken");
    const remember = CommonHelper.getCookie("remember");
    if (remember && token && token.length > 0) {
      const productVersion = CommonHelper.getCookie("product_version");
      this.redirectTo(productVersion);
    }
  },
  methods: {
    switchQrcode() {
      this.$data.operationType = "";
      this.$data.qrcodeTargetShow = !this.$data.qrcodeTargetShow;
      this.$data.qrcodeTargetTitle = this.$data.qrcodeTargetShow
        ? "扫码登录"
        : "返回";
      if (this.$data.qrcodeTargetShow) {
        this.unsubscribeTimer();
      } else {
        setTimeout(() => {
          this.generateQRCode();
        }, 0);
      }
    },
    refreshQrcode() {
      this.$data.operationType = "";
      this.unsubscribeTimer();
      this.generateQRCode();
    },
    unsubscribeTimer() {
      if (this.$data.timer$) {
        this.$data.timer$.unsubscribe();
        this.$data.timer$ = null;
      }
    },
    generateQRCode() {
      this.$data.qrcodeData = CommonHelper.getUUID();
      const data = `ScanLogin:${this.$data.qrcodeData}`;
      const qrcode$ = document.getElementById("qrcode");
      const seft = this;
      QRCode.toCanvas(
        qrcode$,
        data,
        {
          errorCorrectionLevel: "H",
        },
        function (error) {
          if (error) {
            console.error(error);
          }
          seft.$data.qrcodeCreateTime = new Date().getTime();
          seft.checkQRCodeScan();
        }
      );
    },
    checkQRCodeScan() {
      const seft = this;
      this.$data.timer$ = interval(3000)
        .pipe(
          switchMap(() =>
            axios.get(
              EnvConfig.JAVA_BASE_ADDR +
                "/v1/saas/Users/scanCodeLogin?id=" +
                this.$data.qrcodeData
            )
          )
        )
        .subscribe(
          (response) => {
            const passTime = new Date().getTime() - this.$data.qrcodeCreateTime;
            if (passTime > 60000) {
              this.$data.operationType = "4";
              this.unsubscribeTimer();
            } else {
              seft.scanLogin(response.data);
            }
          },
          (error) => {
            console.log(error);
          },
          () => {
            console.log("complete!");
            seft.$data.timer$.unsubscribe();
          }
        );
    },
    scanLogin(result) {
      if (result.code === 0 && result.data) {
        this.$data.operationType = result.data.operationType;
        if (this.$data.operationType === "0") {
          console.log("请使用手机客户扫描二维码");
        } else if (this.$data.operationType === "1") {
          console.log("请使用手机客户端确认登录");
        } else if (this.$data.operationType === "2") {
          console.log("手机客户端确认登录");
          const data = Object.assign({}, result.data, { loginType: 1 });
          this.loginSuccess(data, "", null);
        } else if (this.$data.operationType === "3") {
          console.log("手机客户端取消登录");
        } else if (this.$data.operationType === "4") {
          console.log("二维码已失效");
        }
      }
    },
    refreshCaptcha() {
      const username = this.$refs["loginForm"].model["username"];
      this.$data.captchaSrc =
        EnvConfig.JAVA_BASE_ADDR +
        "/v1/saas/Users/captcha?username=" +
        username +
        "&_=" +
        Date.now();
    },
    submitForm(formName) {
      // 判断当前设备 移动端: true  pc端: false
      // const flag = navigator.userAgent.match(
      //   /(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      // );

      // 判断规则先去除 供ipad使用
      // if (flag) {
      //   this.isWap = !this.isWap;
      //   return;
      // }
      // 判断是否IE浏览器
      var isIE = !!window.ActiveXObject || "ActiveXObject" in window;
      console.log("是否是ie浏览器", isIE);
      if (isIE) {
        document.getElementById("incompatible_tip").style.cssText =
          "display:block;";
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.$refs["loginForm"].model, {
            password: CommonHelper.encypt(
              this.$refs["loginForm"].model["password"]
            ),
          });
          axios
            .post(EnvConfig.JAVA_BASE_ADDR + "/v1/saas/Users/Login", params)
            .then((response) => {
              const result = response.data;
              if (result.data && result != null) {
                const data = result.data;
                data.remember = params.remember;
                if (result.code === 0) {
                  this.loginSuccess(data);
                } else {
                  this.$alert(result.message, "", {
                    customClass: "alert-login-error",
                    type: "error",
                    confirmButtonText: "确定",
                  });
                  this.$data.showSecurityCode = data.is_require_captcha;
                  if (this.$data.showSecurityCode) {
                    this.refreshCaptcha();
                  }
                }
              } else {
                this.$alert(result.message, "", {
                  customClass: "alert-login-error",
                  type: "error",
                  confirmButtonText: "确定",
                });
              }
            })
            .catch((error) => {
              this.$data.registering = false;
              this.$alert("服务器繁忙！请重试", "", {
                customClass: "alert-login-error",
                type: "error",
                confirmButtonText: "确定",
              });
            });
        } else {
          return false;
        }
      });
    },
    loginSuccess(data, redirectTo, routeParams) {
      CommonHelper.setCookie("remember", data.remember);
      CommonHelper.setCookie("loginType", data.loginType || 0);
      CommonHelper.setCookie("station_id", data.station_id || "");
      CommonHelper.setCookie("accessToken", data.token);
      CommonHelper.setCookie("userName", data.user_name || data.username);
      CommonHelper.setCookie("userId", data.user_id);
      CommonHelper.setCookie("accountId", data.a_id);
      CommonHelper.setCookie("componyId", data.c_id);
      CommonHelper.setCookie("componyName", data.c_name);
      CommonHelper.setCookie("componyFullName", data.c_full_name);
      CommonHelper.setCookie("avatarPath", data.avatar_path);
      CommonHelper.setCookie("business_a_id", data.business_a_id);
      CommonHelper.setCookie("product_version", data.product_version);
      if (data.a_is_initialized) {
        CommonHelper.setCookie("a_is_initialized", data.a_is_initialized);
      }
      if (data.new_system && +data.new_system === 1) {
        CommonHelper.setCookie("new_system", true);
      } else {
        CommonHelper.setCookie("new_system", false);
      }
      // 判断是否首次登录，需要修改密码
      if (data.change_password) {
        // 如果是，跳转到修改密码界面
      }
      this.redirectTo(data.product_version);
    },
    redirectTo(productVersion) {
      let domain = EnvConfig.SME_DOMAIN;
      if (productVersion === "1") {
        // 中小企业版
        domain = EnvConfig.SME_DOMAIN;
      } else if (productVersion === "2") {
        // 商贸版
        domain = EnvConfig.TMS_DOMAIN;
      } else if (productVersion === "4") {
        // 阿米巴版
        domain = EnvConfig.AMB_DOMAIN;
      } else if (productVersion === "16") {
        // 财务版
        domain = EnvConfig.FMS_DOMAIN;
      } else if (productVersion === "32") {
        // 进销存版
        domain = EnvConfig.PSI_DOMAIN;
      } else if (productVersion === "64") {
        // 人事版
        domain = EnvConfig.OA_DOMAIN;
      } else if (productVersion === "128") {
        // 客户管理版
        domain = EnvConfig.CRM_DOMAIN;
      }
      location.href = domain;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  .login-form {
    .el-form-item {
      a {
        float: right;
      }
      .verify_code {
        width: 95px;
        cursor: pointer;
      }
    }
  }
}

.qrcodeState {
  position: absolute;
  width: 196px;
  text-align: center;
  height: 196px;
  left: 50%;
  margin-left: -98px;
  .qrcode-error-mask {
    position: absolute;
    width: 196px;
    text-align: center;
    height: 196px;
    background: #000;
    opacity: 0.6;
  }
  .qrcode-error-title {
    position: absolute;
    top: 50px;
    width: 100%;
    color: #fbfbfb;
    font-weight: 700;
  }
  .qrcode-success-title {
    width: 162px;
    height: 162px;
    background-color: #fff;
    i {
      color: green;
      font-size: 36px;
      margin-bottom: 10px;
    }
    div {
      margin-bottom: 10px;
    }
  }
  .refresh-btn {
    background: #e4393c;
    width: 80px;
    height: 30px;
    line-height: 30px;
    color: #fbfbfb;
    cursor: pointer;
    margin: 20px auto;
  }
}

#qrcode {
  border: 1px solid #f4f4f4;
  margin-bottom: 10px;
}

.qrcode-target-show {
  background-position: -198px -200px;
}

.qrcode-target-hide {
  background-position: -298px -300px;
}

.qrcode-target {
  width: 96px;
  height: 96px;
  transition: background-position 0.2s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  background-image: url("../../assets/qrcode-target.png");
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 8px 0 0;
}
.qrcode-container {
  text-align: center;
  height: 268px;
}
.hide-position {
  position: absolute;
  top: 0;
  right: 0;
  width: 90px;
  height: 45px;
}
.qrcode-tip {
  margin-bottom: 8px;
}
.box_wap {
  position: relative;
  width: 90%;
  height: 30%;
  color: #fff;
  h4 {
    font-size: 22px;
    line-height: 40px;
  }
}
@media (max-width: 768px) {
  .body-container {
    .box {
      width: 94%;
      padding: 50px 5%;
    }
  }
}
</style>
